
import useDialog from '@/utils/useDialog'
import { CloseIcon } from '@/componentsUI/Icon'
import React from 'react'
import './index.less'
import Icon from '../../../../../pages/redpackRain/assets/jqnc_xq.svg';
import useDialogManager from '@/utils/useDialogManager';
import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import { useCurrency } from '@/hooks/useCurrency';
const DialogWheelHeader = ({ onClose }: { onClose?: () => void }) => {
    const {  closeAll } = useDialog()

    const { openDialogInviteWheelHelp } = useDialogManager()

    const {t} = useTranslationPlus()
    const currency = useCurrency()

    return (
        <div className="wheel-header">
            <button type="button" className="wheel-icon-info wheel-button" onClick={openDialogInviteWheelHelp}>
                <Icon />
            </button>
            <div className="wheel-header-title">
                {t('shareFriendWheel.title', { currency })}
            </div>
            <button type="button" className="wheel-close-icon wheel-button"
                onClick={() => {
                    onClose?.()
                    closeAll()
                }}
            >
                <CloseIcon className={'svg-icon'} />
            </button>
        </div>
    )
}

export default DialogWheelHeader
